import { getTag, useSitemap, useTranslation, useUrlContext } from '@msdk/common'
import {
  ButtonIcon,
  ClickAwayListener,
  Collapsible,
  createComponentWrapperWithRef,
  THEME_CONST,
  Tooltip,
  Z_INDEX,
} from '@msdk/ui'
import { KeyboardDoubleArrowLeft as IconMenuExpanded, Menu as IconMenuCollapsed } from '@mui/icons-material'
import { styled } from '@mui/material'
import { Sidebar } from 'components/Sidebar'
import { NovaSidebarItem, SidebarItem } from 'components/Sidebar/SidebarItem'
import { useNavigationMenu } from 'state/navigation-menu'

const AppName = styled('div')`
  padding: 4px 0 0;
`

export const StyledCollapsible = styled(Collapsible)`
  z-index: ${Z_INDEX.sidebar};
  & .MuiDrawer-paper {
    position: absolute;
    padding-top: ${THEME_CONST.navHeight}px;
    z-index: ${Z_INDEX.sidebar};
  }

  svg {
    fill: currentColor;
  }
`

const MuiSideIconButton = styled(ButtonIcon)`
  ${SidebarItem};
  margin: 8px 12px;
`

const NovaSideIconButton = styled(ButtonIcon)`
  ${NovaSidebarItem};
  margin: 8px 12px;
`

const SideIconButton = createComponentWrapperWithRef(
  {
    mui: MuiSideIconButton,
    nova: NovaSideIconButton,
  },
  'SideIconButton',
)

export function SideMenu() {
  const urlCtx = useUrlContext()
  const sitemapModel = useSitemap(urlCtx.context.sitemap)

  const { navigationMenuOpen, setNavigationMenu } = useNavigationMenu()

  const t = useTranslation()

  const label = navigationMenuOpen ? 'close' : 'open'
  const title = navigationMenuOpen
    ? t('LBL_SIDEMENU_COLLAPSE', 'Collapse menu')
    : t('LBL_SIDEMENU_EXPAND', 'Expand menu')

  return (
    <ClickAwayListener onClickAway={() => setNavigationMenu(true)}>
      <StyledCollapsible
        variant="permanent"
        anchor="left"
        open={navigationMenuOpen}
        data-test-id="SHELL-SIDEMENU-CONTAINER"
      >
        <AppName>
          <Tooltip title={title} placement="right">
            <SideIconButton
              aria-label={label}
              onClick={() => setNavigationMenu(navigationMenuOpen)}
              data-test-id={getTag('shell', 'sidemenu', label, 'icon')}
            >
              {navigationMenuOpen ? <IconMenuExpanded /> : <IconMenuCollapsed />}
            </SideIconButton>
          </Tooltip>
        </AppName>
        <Sidebar sitemapModel={sitemapModel} />
      </StyledCollapsible>
    </ClickAwayListener>
  )
}
